import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { useEffect } from "react";
import { graphql, useFragment } from "react-relay";

import { rosettaAtom } from "~/lib/rosetta";
import type { articlePaywallCheckerArticle$key } from "~/queries/__generated__/articlePaywallCheckerArticle.graphql";

import { usePaywallPromise } from "./hooks";

type Props = {
  article: articlePaywallCheckerArticle$key;
};

export const ArticlePaywallChecker: FunctionComponent<Props> = ({ article: article_ }) => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const article = useFragment(
    graphql`
      fragment articlePaywallCheckerArticle on Article {
        ...hooksPaywallPromiseArticle
      }
    `,
    article_,
  );

  const isShowInlinePaywall = usePaywallPromise(article);

  useEffect(() => {
    if (!isShowInlinePaywall || asyncRosettaState?.status === "loading") return;
    // TODO: handle show inline paywall offer at here
    // Mainly for tracking
  }, [asyncRosettaState?.status, isShowInlinePaywall]);

  return null;
};

ArticlePaywallChecker.displayName = "ArticlePaywallChecker";
